import { render, staticRenderFns } from "./FapiaoDetail.vue?vue&type=template&id=ee6cf6c0&scoped=true&"
import script from "./FapiaoDetail.vue?vue&type=script&lang=js&"
export * from "./FapiaoDetail.vue?vue&type=script&lang=js&"
import style0 from "./FapiaoDetail.vue?vue&type=style&index=0&id=ee6cf6c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee6cf6c0",
  null
  
)

export default component.exports